import React, { FC } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppCol, AppFieldBox, AppRow } from 'components/appComponents';
import { Button, Validator } from 'devextreme-react';
import { NumberBox } from 'devextreme-react';

type DeliveryProps = {
  value: number;
  quantity: number;
  price: number;
  pumpDelivery: number;
  delivery: number;
  readOnly: boolean;
  onChange: (value: number) => void;
  onRevert: () => void;
};

const Delivery: FC<DeliveryProps> = ({
  value,
  readOnly,
  onChange,
  quantity,
  price,
  delivery,
  pumpDelivery,
  onRevert,
}) => {
  return (
    <>
      <AppFieldBox label="Доставка" labelTop>
        <AppRow>
          <AppCol col={11}>
            <NumberBox
              stylingMode="underlined"
              placeholder="Цена за куб"
              readOnly={readOnly}
              //mode="text"
              format="###0.##"
              value={value}
              onValueChange={(e) => onChange(e)}
            >
              <Validator>
                <RequiredRule message="Заполните поле Цена за куб" />
              </Validator>
            </NumberBox>
          </AppCol>
          <AppCol col={1}>
            <Button icon="revert" onClick={onRevert} />
          </AppCol>
        </AppRow>
      </AppFieldBox>

      <div style={{ fontWeight: 'bold', fontSize: 16 }}>
        Итого: {(quantity * price + delivery + pumpDelivery).toFixed(2)}
      </div>
    </>
  );
};

export default Delivery;
